import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import Currency from '../../../models/Currency';
import RegionalSettingsOptionLabel from '../RegionalSettingsOptionLabel';

@observer
class CurrencyLabel extends Component {
  render() {
    const { currency } = this.props;
    const symbol = (
      <span
        className="CurrencyLabel__symbol"
        dangerouslySetInnerHTML={{ __html: currency.symbol }}
      />
    );

    return (
      <span className="CurrencyLabel">
        <RegionalSettingsOptionLabel lead={symbol} trail={currency.code} />
      </span>
    );
  }
}

CurrencyLabel.propTypes = {
  currency: modelOf(Currency).isRequired,
};

export default CurrencyLabel;
